import useIntegratedEquipmentEnabled from 'components/domain/equipment/IntegratedEquipmentLocationDialog/hooks/useIntegratedEquipmentEnabled';
import { useEffect, useState } from 'react';
import useEquipmentDevices from './useEquipmentDevices';

export default function useEquipmentDeviceEsnMap(): ReadonlyMap<string, string> {
  const hasGpsHardware = useIntegratedEquipmentEnabled();
  const fetchDevices = useEquipmentDevices();
  const [esnByEquipmentId, setEsnByEquipmentId] = useState<ReadonlyMap<string, string>>(() => new Map());

  useEffect(() => {
    let cancelled = false;

    if (!hasGpsHardware) {
      setEsnByEquipmentId(new Map());
      return;
    }

    fetchDevices(hasGpsHardware).then((devices) => {
      if (cancelled) {
        return;
      }
      const map = new Map<string, string>();
      devices.forEach((device) => {
        if (device.equipment_id && device.esn && !map.has(device.equipment_id)) {
          map.set(device.equipment_id, device.esn);
        }
      });
      setEsnByEquipmentId(map);
    });

    return () => {
      cancelled = true;
    };
  }, [hasGpsHardware, fetchDevices]);

  return esnByEquipmentId;
}
